<template>
  <div class="root">
    <div class="card">
      <router-link class="card-header-container" :to="clickTarget">
        <div class="card-header">
          {{ rux.shortDescription }}
          <span
            v-if="showDelete"
            @click.prevent="deleteClick"
            class="material-symbols-outlined pointer delete"
            >delete</span
          >
        </div>
        <div v-if="showLongDescription">{{ rux.fullDescription }}</div>
        <div class="packing-list-item" v-if="rux.packingListItems.length > 0">
          {{ rux.packingListItems.length }} items
        </div>
        <div v-else class="packing-list-item">No items</div>
        <!-- <div class="row push-down-20">
          <div class="col-6" v-for="(image, index) in images" :key="index">
            <img :src="image" class="thumbs" />
          </div>
        </div> -->
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  // Basic component that displays a RUX and its images
  name: 'RuxCard',
  props: [
    'rux',
    'images',
    'clickTarget',
    'showSerial',
    'showLongDescription',
    'showDelete',
    'handleDelete',
  ],
  methods: {
    deleteClick: function () {
      this.$emit('handleDelete')
    },
  },
}
</script>

<style lang='scss' scoped>

.material-symbols-outlined {
  color: black;
}

.card {
  padding: 17px;
  border-radius: 0px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  border: 1px solid black;
  overflow: hidden;
  .delete {
  }
  .card-header-container {
    width: 100%;
  }
  .card-header {
    color: black;
    background-color: white;
    text-transform: uppercase;
    border-bottom: 0px;
    font-size: 20px;
    padding: 0px;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .serial-number {
    font-size: smaller;
  }
  .packing-list-item {
    padding: 0px;
    margin: 0px;
    text-align: left;
    color: black;
    opacity: 0.5;
    font-family: "Neue Roman";
  }
  .thumbs {
    height: 125px;
    max-width: 125px;
    @include respond-to('sm') {
      height: 90px;
      max-width: 90px;
    }
    @include respond-to('lg') {
      height: 125px;
      max-width: 125px;
    }
    margin: 0 auto;
    display: flex;
    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.19), 0 2px 2px rgba(0, 0, 0, 0.23);
  }
}
h4 {
  color: $ruxRed;
}
div {
  color: #2c3e50;
}
a:hover {
  text-decoration: none;
}
</style>